// Shows a "timeline" for an asset allowing the user to navigate to different revisions (using the #asof=date argument)
// Mostly for debugging at the moment, but could be turned into a more complete feature if desired.

import { FetchError } from 'errors'
import { useHash } from 'hooks/use-hash'
import { AssetType } from 'lib/assets/asset'
import useSWR from 'swr'

type Props = {
  assetType: AssetType
  uuid?: string
  asof: string
}

const circleStyle: React.CSSProperties = {
  display: 'inline-block',
  width: '12px',
  height: '18px',
  border: '1px solid grey',
  borderRadius: '4px',
  margin: '0 2px',
  cursor: 'pointer',
}

const DateLine = ({ assetType, uuid, asof }: Props) => {
  // Don't show line unless an asof argument has been provided
  const { hash } = useHash()
  const shouldFetch = hash.indexOf('asof') > -1

  let apiUrl = `/api/assets/${assetType}/dates`
  if (uuid) {
    apiUrl += '?uuid=' + uuid
  }

  if (!shouldFetch) {
    apiUrl = null
  }

  const { data: dates, error, isLoading } = useSWR<string[]>(apiUrl)

  if (!shouldFetch) {
    return <></>
  }

  if (error) {
    throw new FetchError()
  }

  if (isLoading || !dates) {
    return <div className="m2 sm">Loading...</div>
  }

  const handleClick = (date: string) => {
    window.location.hash = `#asof=${date}`
  }

  return (
    <div className="m-2">
      {dates.map((date) => (
        <span
          key={date}
          onClick={() => handleClick(date)}
          style={{
            ...circleStyle,
            backgroundColor: date === asof ? 'grey' : 'transparent',
          }}
          title={date}
        />
      ))}
      <span
        key="now"
        onClick={() => handleClick('')}
        style={{
          ...circleStyle,
          backgroundColor: !asof ? 'grey' : 'transparent',
        }}
        title="now"
      />
    </div>
  )
}

export default DateLine
